<template>
  <div style="margin: 0; padding: 0; box-sizing: border-box; background-color: #ffffff;">
    <!-- 顶部渐变横幅 -->
    <div
      style="width: 100%; height: 50vh;
             background: linear-gradient(180deg, #b8e0fc 0%, #74c0f5 100%);
             position: relative;
             display: flex;
             flex-direction: column;
             justify-content: center;
             align-items: center;">

      <!-- 中间文字区域 -->
      <div style="text-align: center;">
        <p style="font-size: 36px; color: #223344; font-weight: bold; margin:0;">国星智能</p>
        <p style="font-size: 18px; color: #557799; margin:8px 0 0 0;">专注智能技术产品与服务</p>
      </div>

      <!-- 二维码容器，两栏并排 -->
      <div style="display:flex;justify-content:center;gap:60px;flex-wrap:wrap;margin-bottom:60px;margin-top:30px;">
        <!-- 小程序二维码 -->
        <div style="text-align:center;">
          <div style="width:140px;height:140px;border-radius:8px;background:#ffffff;border:1px solid #e8e8e8;overflow:hidden;">
            <img :src="require('@/assets/miniqrcode.jpg')" alt="小程序码" style="width:100%;height:100%;object-fit:contain;" />
          </div>
          <p style="margin-top:12px;font-size:15px;color:#444;">扫码进入小程序</p>
        </div>

        <!-- APP下载二维码 -->
        <div style="text-align:center;">
          <div style="width:140px;height:140px;border-radius:8px;background:#ffffff;border:1px solid #e8e8e8;overflow:hidden;">
            <img :src="require('@/assets/downUrl.png')" alt="APP下载码" style="width:100%;height:100%;object-fit:contain;" />
          </div>
          <p style="margin-top:12px;font-size:15px;color:#444;">扫码下载APP</p>
        </div>
      </div>

      <!-- 右下角备案号 -->
      <div
        style="position: absolute; right:24px; bottom:14px; z-index:99;
               font-size:17px; font-weight:bold;
               padding:10px 16px; border-radius:8px;
               background:#ffffff;
               box-shadow: 0 2px 10px rgba(0,0,0,0.08);">
        <a href="https://beian.miit.gov.cn" target="_blank"
           style="color:#224477; text-decoration:none;">
           粤ICP备17092702号
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>
/* 清空，全部用内联，这里留空，防止干扰 */
</style>